import React from 'react'
import Img from 'gatsby-image'

import styles from './hero.module.css'

export default ({ data }) => (

      <p>{data.shortBio.shortBio}</p>
)



// WEBPACK FOOTER //
// ./src/components/hero.js